import { Box, Typography, Divider } from "@mui/material";
import { grayPrimaryFontColor } from "../cssUtils/constants";
import typography from "../cssUtils/typography";

const DashboardStatSection = ({
  items = [], // [{ label, value, valueColor, Icon }]
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        mb: 2,
      }}
    >
      {items.map((item, index) => (
        <Box key={index}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: "13px",
            }}
          >
            {/* Left Label */}
            <Typography sx={typography.bodyLarge}>{item.label}</Typography>

            {/* Right Value + Optional Icon */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography
                variant="body2"
                sx={{
                  ...typography.bodyLarge,
                  fontWeight: 600,
                  color: item.valueColor || "#000000",
                }}
              >
                {item.value}
              </Typography>

              {item.Icon && (
                <item.Icon
                  sx={{
                    fontSize: 16,
                    color: item.valueColor || "inherit",
                  }}
                />
              )}
            </Box>
          </Box>

          {/* Divider except last item */}
          {<Divider />}
        </Box>
      ))}
    </Box>
  );
};

export default DashboardStatSection;
